import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as _ from 'lodash';
import { VerbatimService } from 'src/app/shared/services/verbatim/verbatim.service';
import { NgClass, NgIf, NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LtmsDataTableV2Component } from '../../../../shared/components/ltms-data-table-v2/ltms-data-table-v2.component';
@Component({
    selector: 'app-project-inbox-sent',
    templateUrl: './project-inbox-sent.component.html',
    styleUrls: ['./project-inbox-sent.component.scss'],
    imports: [
        NgClass,
        FormsModule,
        NgIf,
        NgFor,
        LtmsDataTableV2Component,
    ]
})
export class ProjectInboxSentComponent implements OnInit {
  constructor(public _utilsService: UtilsService, private _helpers: HelpersService, public _verbatim: VerbatimService) { }
  destroyRef = inject(DestroyRef);
  brandDetails = Helpers.brandDetails;
  fromDate!: number;
  toDate!: number;
  params = {}
  responded_list = {};
  non_responded_list = {};
  prepared_responded_list: any[] = [];
  prepared_non_responded_list: any[] = [];
  errorCode = '404';
  requestsJourneyHeader: any[] = [];
  isDataAvailable = false;
  configs = {
    isCollapsable: false
  }

  default_selected_type = 'CFR';
  total_count_of_data = 0;
  page_number = 1;
  show_data_count_from = 1;
  isNext = true;
  isFirstPage = true;
  lastReceivedCount = 0;
  isPreviousClicked = false;
  isNextClicked = false;
  brandOffsetName = {}
  // ===================================== Search ==============================
  searchText = "";
  searchAvailableOnList = [{
    field_id: "name",
    field_text: "Name"
  },
  {
    field_id: "email_address",
    field_text: "Email Address"
  },
  {
    field_id: "phone_number",
    field_text: "Phone Number"
  }
  ];
  defaultSelectedField = this.searchAvailableOnList[1];
  showFilterFields = false;
  showSearchList = false;
  searchResult: any = {};
  placeholder = "Please search and select";
  isTextEntered = false;

  ngOnInit() {
    this.brandOffsetName = this._helpers.getBrandTimezoneDetails(this.brandDetails);
    this._helpers.appState.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((state: any) => {
      if (state && !state.pending) {
        this.prepared_responded_list = [];
        this.prepared_non_responded_list = []
        this.lastReceivedCount = 0;
        this.total_count_of_data = 0;
        if (this.default_selected_type == 'CFR') {
          this.getCFR();
        }
        if (this.default_selected_type == 'CFRA') {
          this.getCFRA();
        }
      }

    })
  }

  loadData(requst_type) {
    this.total_count_of_data = 0;
    this.page_number = 1;
    this.show_data_count_from = 1;
    this.isNext = true;
    this.isFirstPage = true;
    this.lastReceivedCount = 0;
    this.isPreviousClicked = false;
    this.isNextClicked = false;
    this.loadDataByType(requst_type)
  }


  loadDataByType(requst_type) {
    this.default_selected_type = requst_type;
    this.prepared_responded_list = [];
    this.prepared_non_responded_list = []
    if (requst_type == 'CFR') {
      this.requestsJourneyHeader = []
      this.getCFR();
    } else if (requst_type == 'CFRA') {
      this.getCFRA();
    }

  }


  // Get responded data
  getCFRA() {
    this.getListByType(true, (responded_list) => {
      this.prepareDetails(responded_list, 'cfra')
    })
  }

  // Refresh the data based on selected type(CFR and CFRA)
  refreshData() {
    this.loadData(this.default_selected_type)
  }

  // Get NoN responded data
  getCFR() {
    this.getListByType(false, (responded_list) => {
      this.prepareDetails(responded_list, 'cfr')
    })
  }

  next_page() {
    this.isNextClicked = true;
    this.page_number = this.page_number + 1;
    this.isFirstPage = false;
    this.loadDataByType(this.default_selected_type)
    this.show_data_count_from = this.show_data_count_from + this.lastReceivedCount;
  }

  previous_page() {
    this.isPreviousClicked = true;
    if (this.page_number != 1) {
      this.page_number = this.page_number - 1;
      this.show_data_count_from = this.show_data_count_from - 10;
      this.loadDataByType(this.default_selected_type)
    } else {
      this.isFirstPage = true;
    }
  }

  // Get reponded and non responded list 
  getListByType(is_archived, cb) {
    this.params['brand_id'] = this.brandDetails._id;
    this.params['version'] = 'v1';
    this.params['limit'] = 10;
    this.params['page_number'] = this.page_number;
    this.params['is_archived'] = is_archived;
    this.params['to'] = _.get(Helpers, "datePicker.endDate");
    this.params['from'] = _.get(Helpers, "datePicker.startDate")
    this._verbatim.getListForSentTab(this.params).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((feedsDetail) => {
      if (feedsDetail && feedsDetail['data'] && feedsDetail['data']['code'] == 0 && feedsDetail['data']['total'] > 0) {
        this.isDataAvailable = true;
        cb(feedsDetail['data']);
      } else {
        if (is_archived) {
          this.prepared_responded_list = []
        } else {
          this.prepared_non_responded_list = [];
        }
        this.isDataAvailable = false;
        cb([])
      }
    })
  }

  prepareDetails(data, type) {
    if (data && data['requests'] && data['requests'].length > 0 && data['shops'] && data['users'] && data['total'] > 0) {
      this.total_count_of_data = this.total_count_of_data + data['total'];
      this.lastReceivedCount = data['total'];
      if (data['total'] < 10) {
        // No more data for paging
        this.isNext = false;
      } else {
        this.isNext = true;
      }

      if (this.isNextClicked) {
        console.log("Data Showing from :", this.show_data_count_from, " to: ", this.total_count_of_data)
      }

      if (this.isPreviousClicked) {
        this.total_count_of_data = this.total_count_of_data - data['total'];
      }

      this.prepared_responded_list = _.map(data['requests'], (cfra) => {
        const data: any = {};
        data['Name'] = (cfra['tag_private_user_name']) ? cfra['tag_private_user_name'] : "Anonymous";
        data['Phone Number'] = (cfra['tag_private_phone_number']) ? cfra['tag_private_phone_number'] : "NA";
        data['Email Address'] = (cfra['tag_private_email_address']) ? cfra['tag_private_email_address'] : "NA";
        data['Whatsapp Number'] = (cfra['tag_private_whatsapp_number']) ? cfra['tag_private_whatsapp_number'] : "NA";
        data['Last Attempt'] = (cfra['attempts']) ? cfra['attempts'] : "NA";
        // data['last_channel_details'] = this.getLastAttemptDetails(cfra['trials']);
        if (type == 'cfra') {
          data['Request Date'] = this._helpers.getTimeByOffset(this.brandOffsetName["__zone_symbol__value"]['offset'], cfra['feedback_request_date'], "DD-MMM-YY HH:mm");
          data['Respond Date'] = this._helpers.getTimeByOffset(this.brandOffsetName["__zone_symbol__value"]['offset'], cfra['created_date'], "DD-MMM-YY HH:mm");
          data['Responded On'] = this.getRespondedDetails(cfra['interaction']);
        } else if (type == 'cfr') {
          data['Created Date'] = this._helpers.getTimeByOffset(this.brandOffsetName["__zone_symbol__value"]['offset'], cfra['created_date'], "DD-MMM-YY HH:mm");
          if (cfra['_id'] != null) {
            data['Link'] = _.get(this.brandDetails, "conversation_config.feedbacks.url") + 'v2/' + cfra['_id'] + "?utm_medium=link&utm_term=trial_1";
            data['Link'] = '<a  href="' + data['Link'] + '" target="_blank" >Click Here</a>'
          }
        }
        if (_.get(this.brandDetails, "is_single_touchpoint_setup")) {
          data['Touchpoint Name'] = (cfra['tag_private_group_hierarchy_0_id']) ? cfra['tag_private_group_hierarchy_0_id'] : "NA";
        } else {
          // #todo
          data['Touchpoint Name'] = "Static Project"
        }
        return data;
      })
      if (type == 'cfra') {
        this.generateDynamicColunms(this.prepared_responded_list, type)
      }
      if (type == 'cfr') {
        this.generateDynamicColunms(this.prepared_responded_list, type)
      }
    } else {
      this.prepared_responded_list = [];
      this.prepared_non_responded_list = [];
    }
  }


  getRespondedDetails(interaction) {
    const responded_on = _.find(interaction, { interaction_type: 'rate' });
    if (responded_on && responded_on['utm_medium']) {
      return responded_on['utm_medium']
    } else {
      return "NA"
    }
  }

  getLastAttemptDetails(trials) {
    if (trials && trials.length > 0) {
      const lastAttemptDetails = _.orderBy(trials, ['attempt'], ['asc']);
      const last_object = lastAttemptDetails.length - 1;
      return lastAttemptDetails[last_object];
    } else {
      return "NA";
    }
  }

  generateDynamicColunms(data, typeofdata) {
    const sampleObject = data[0]
    this.requestsJourneyHeader = []
    let col_order = 0;
    for (const key in sampleObject) {
      const columnNameObject = {}
      if (Object.prototype.hasOwnProperty.call(sampleObject, key)) {
        col_order = col_order + 1
        columnNameObject['header'] = key;
        columnNameObject['dataKey'] = key;
        columnNameObject['dataType'] = typeof sampleObject[key];
        columnNameObject['order'] = col_order;
        columnNameObject['width'] = "20%";
        if (key == 'Name') {
          columnNameObject['width'] = "30%";
        }
        columnNameObject['is_deviation_enabled'] = false;
        columnNameObject['enabled'] = true;
        columnNameObject['ellipsisEnabled'] = true;
        if (col_order == 1) {
          columnNameObject['fixed'] = true;
        }
        if (key && key == 'Link') {
          columnNameObject['isHtmlExist'] = true;
        }
        columnNameObject['style'] = {};
        columnNameObject['style']['headerTextAlign'] = 'left'
        columnNameObject['style']['cellTextAlign'] = 'left'
      }
      this.requestsJourneyHeader.push(columnNameObject);
      this.isDataAvailable = true;
    }
  }


  changeFilterField(field) {
    console.log("asdasd", field, this.showFilterFields)
    this.defaultSelectedField = field;
    this.showFilterFields = false;
  }

  searchUserByType(event: any) {
    const searchText = event.target.value;
    this.isTextEntered = true;
    if (searchText && searchText != "" && searchText.length > 3) {
      const fieldId = this.defaultSelectedField.field_id;
      const params = {};
      params['brand_id'] = this.brandDetails._id;
      params['order'] = 0;
      params['search_type'] = fieldId;
      params['search_text'] = searchText;
      params['limit'] = 10;
      params['from'] = 0;
      params['to_date'] = _.get(Helpers, "datePicker.endDate");
      params['from_date'] = _.get(Helpers, "datePicker.startDate")
      this._verbatim.getUserDetailsByType(params).pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((response: any) => {
        this.searchResult = this.processSerchResult(fieldId, response.data);
      });
    } else {
      this.searchResult = {
        options: [{
          'displayText': "Type somthing to start search.",
          'text': "Type somthing to start search.",
          'id': '',
          isError: true
        }]
      }
    }

    if (this.searchText.length == 0) {
      this.isTextEntered = false;
    }

  }
  toggleSearchList() {
    this.showFilterFields = false;
    if (this.showSearchList) {
      this.showSearchList = false;
    } else {
      this.showSearchList = true;
      this.placeholder = this.searchText || this.placeholder;
      this.searchText = '';
      this.searchResult = {
        options: [{
          'displayText': "Type somthing to start search.",
          'text': "Type somthing to start search.",
          'id': '',
          isError: true
        }]
      }
    }
  }

  clearSearchBox() {
    this.searchText = '';
    this.isTextEntered = false;
    if (this.params['user_id']) {
      delete this.params['user_id'];
      this.loadDataByType(this.default_selected_type);
    }
  }

  searchListSelectedvalue(item) {
    if (!item.isError) {
      this.params['user_id'] = item['id'];
      this.loadDataByType(this.default_selected_type);
      this.showSearchList = false;
    }
  }

  toggleFilterFieldList() {
    this.showSearchList = false;
    if (this.showFilterFields) {
      this.showFilterFields = false;
    } else {
      this.showFilterFields = true;
    }
  }

  processSerchResult(fieldId: string, data: any) {
    if (data && data.code == 0 && data['data'] && data['data'].length > 0) {
      return {
        options: _.map(data.data, (item) => {
          return {
            'displayText': item[fieldId],
            'text': (item['name'] ? item['name'] : '') + " " + (item["phone_number"] ? item["phone_number"] : '') + " " + (item["email_address"] ? item["email_address"] : ''),
            'id': item.user_id,
            isError: false
          }
        })
      }
    } else {
      return {
        options: [{
          'displayText': "No result found",
          'text': "No result found",
          'id': '',
          isError: true
        }]
      }
    }
  }
}
